import { GraphQlClient, Moment } from '@intelipost-js/secure-providers';

export default {
  getExportPerBatchs({ commit }, params) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query(
        $search_by: String,
        $search_values: [String]
      ) {
        exportPerBatch(
          search_by: $search_by,
          search_values: $search_values,
        ) {
          number_of_orders,
          logistic_provider {
            id,
            name,
            logo,
          },
          docs_urls {
            csv,
            txt,
            xlsx,
          }
        }
      }`, params)
      .then((res) => {
        const { data = {} } = res || {};
        const { exportPerBatch = {} } = data || {};

        commit('toggleLoading', false);
        commit('setExportPerBatchs', exportPerBatch);

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },
  getLogisticProvider({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query {
        logisticProvidersToExport {
          logistic_provider {
            id
            name
            logo
          },
          docs_urls {
            csv
            txt
            xlsx
          }
        }
      }`,
    )
      .then((res) => {
        commit('toggleLoading', false);

        const { data = {} } = res || {};
        const { logisticProvidersToExport = [] } = data;

        commit('setLogisticProviders', logisticProvidersToExport);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },
  generateBatchPslExportDownloadLink({ commit }, args) {
    commit('toggleLoading', true);

    const {
      form = {},
      logisticProvider = {},
      key = 'txt',
    } = args || {};

    const {
      date_range = {},
      volume_state = [],
    } = form || {};

    const {
      start = Moment().subtract(1, 'd').format('YYYY-MM-DD'),
      end = Moment().format('YYYY-MM-DD'),
    } = date_range || {};

    const { logistic_provider } = logisticProvider || {};
    const { id } = logistic_provider || {};

    const order_status = volume_state.map(order => order.value);

    const params = {
      logistic_provider_id: id,
      file_type: key,
      date_range_start: Moment(start).format('YYYY-MM-DD'),
      date_range_end: Moment(end).format('YYYY-MM-DD'),
      order_status,
    };

    return GraphQlClient.query(`
      query(
        $logistic_provider_id: String,
        $file_type: String,
        $date_range_start: String,
        $date_range_end: String,
        $order_status: [String],
      ) {
        generatePslBatchDownloadUrl(
          logistic_provider_id: $logistic_provider_id,
          file_type: $file_type,
          date_range_start: $date_range_start,
          date_range_end: $date_range_end,
          order_status: $order_status,
        ) {
          download_url
        }
      }`, params)
      .then((res) => {
        commit('toggleLoading', false);

        const { data } = res || {};
        const { generatePslBatchDownloadUrl } = data || {};
        const { download_url = '' } = generatePslBatchDownloadUrl || {};

        window.open(download_url, '__blank');
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/export-per-batch/store/actions.js